import { useQuery } from '@tanstack/react-query';
import { apiRequest } from '../../../api';
// 1. The "Library" function (CORRECTED for native fetch)
const fetchSheets = async (folderId,section ) => {
  return await apiRequest(`/api/sheets/${folderId}/${section}`, {
    method: 'POST', // Explicitly set POST to match Flask
    body: JSON.stringify({}), // Send an empty object if no data is needed
  }); 
};

// CENTRAL TOP: Folders (scoped to Project + Section)
export const useFolderSheets = (projectId,namespaceId,folderId,section) => {
  return useQuery({
	    queryKey: ['sheets', folderId, section],
	    queryFn: () => fetchSheets({ folderId,section }),
	    enabled: !!projectId && !!namespaceId && !!folderId,
  });
};